module.exports = __webpack_public_path__ + "img/Michigan-02.2a806d26.png";